import React, { Component } from "react"

class RCT2ScenarioVersion extends Component {
// function RCT2ScenarioVersion (props) {
  
  render () {
    return (
      <div className={this.props.id}>
        <h3>{this.props.name} ({this.props.year} Version)</h3>
        <img src={process.env.PUBLIC_URL + `/assets/scenario/${this.props.id}-${this.props.year}/${this.props.name} ${this.props.year}.png`} alt={`${this.props.name} preview`} loading="lazy" />
        <div>
          <p>
            <a href={process.env.PUBLIC_URL + `/assets/scenario/${this.props.id}-${this.props.year}/${this.props.name} ${this.props.year}.sc6`}>{this.props.name}</a> ({this.props.year} version)
            {this.props.buildYourOwn === "true" &&
            <>
              <br />
              <a href={process.env.PUBLIC_URL + `/assets/scenario/${this.props.id}-${this.props.year}/Build your own ${this.props.name} ${this.props.year}.sc6`}>Build your own {this.props.name}</a> ({this.props.year} version)
            </>
            }
          </p>
          <p className="note">{this.props.note}</p>
        </div>
      </div>
    )
  }
}

export default RCT2ScenarioVersion